import { IdlePreviewResponse } from '../../../../services/ocpp/types';

export enum IdlePhase {
  Free = 'free',
  Billable = 'billable',
}

export interface IdlePhaseResult {
  kind: IdlePhase;
  fillPercent: number;
  freeMinutesRemaining: number;
  billableMinutes: number;
  pricePerMinute: number;
  amount: number;
}

/**
 * Derive the idle bar's phase and fill from a live idle preview.
 * - `free`: still within the free window — bar fills as free time is consumed.
 * - `billable`: free window exhausted — bar is full, fee is accruing.
 */
export const idlePhase = (preview: IdlePreviewResponse): IdlePhaseResult => {
  const {
    freeMinutes,
    freeMinutesRemaining,
    billableMinutes,
    pricePerMinute,
    amount,
  } = preview;

  const isBillable = freeMinutesRemaining <= 0 && freeMinutes >= 0;

  let fillPercent: number;
  if (isBillable) {
    fillPercent = 100;
  } else if (freeMinutes > 0) {
    const used = freeMinutes - freeMinutesRemaining;
    fillPercent = Math.min(100, Math.max(0, (used / freeMinutes) * 100));
  } else {
    fillPercent = 0;
  }

  return {
    kind: isBillable ? IdlePhase.Billable : IdlePhase.Free,
    fillPercent,
    freeMinutesRemaining: Math.max(0, freeMinutesRemaining),
    billableMinutes: Math.max(0, billableMinutes),
    pricePerMinute,
    amount,
  };
};
